import { Component, Input, OnInit } from '@angular/core';
import { LocaleService } from '@career/core/services/locale.service';

@Component({
  selector: 'app-default-upload-file',
  templateUrl: './default-upload-file.component.html',
  styleUrls: ['./default-upload-file.component.scss']
})
export class DefaultUploadFileComponent implements OnInit {

  @Input() scope;
  resumeOrCvText = this.localeService.getResumeOrCVText();
  constructor(private localeService: LocaleService) { }

  ngOnInit(): void {
  }

}
